import setReduxAction from 'modules/redux/actions/set'
import removeReferenceUtil from 'modules/training/modules/references/utils/remove'
import { REFERENCES_ACTION, REFERENCES_DOMAIN } from 'modules/training/modules/references/constants'

function removeReferenceAction (params) {
  return (dispatch, getState) => {
    const domain = removeReferenceUtil({
      ...params,
      state: getState()
    })
    // If the reference does not exists, no-op
    if (!domain) {
      return
    }
    dispatch(
      setReduxAction({
        type: REFERENCES_ACTION.DELETE,
        payload: {
          path: REFERENCES_DOMAIN,
          value: domain
        }
      })
    )
  }
}

export default removeReferenceAction
